import { render, staticRenderFns } from "./KBreadcrumbs.vue?vue&type=template&id=4c29cafd&scoped=true&"
import script from "./KBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./KBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./KBreadcrumbs.vue?vue&type=style&index=0&id=4c29cafd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c29cafd",
  null
  
)

export default component.exports